/**
 * The invitation's cache entry: asked for once by InvitationGate and kept for the
 * visit, then forgotten by the form once its feedback is sent.
 */
export const invitationQueryKey = (invitationId: string) =>
  ["invitation", invitationId] as const
